export default __webpack_public_path__ + "static/media/6.1.c27ff503.mp4";